import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from "react";
import { EditorState } from "@codemirror/state";
import { EditorView, basicSetup } from "codemirror";
import { json } from "@codemirror/lang-json";
import { Box } from "@mantine/core";
export const CodeEditor = ({ value = "", onChange, }) => {
    const editorRef = useRef(null);
    const containerRef = useRef(null);
    const changeRef = useRef(onChange);
    changeRef.current = onChange;
    const currentValue = useRef(value);
    currentValue.current = value;
    /**
     * Update listener cannot be changed once state is initialized
     * Handling changes to current value and onChange will use refs
     */
    const updateListener = useMemo(() => {
        return EditorView.updateListener.of(({ state }) => {
            if (currentValue.current !== state.doc.toString()) {
                changeRef.current?.(state.doc.toString());
            }
        });
    }, []);
    /**
     * Initialize editor on mount
     */
    useEffect(() => {
        if (!containerRef.current)
            return;
        if (editorRef.current)
            return;
        const state = EditorState.create({
            doc: value,
            extensions: [basicSetup, json(), updateListener],
        });
        editorRef.current = new EditorView({
            parent: containerRef.current,
            state,
        });
    }, [updateListener, value]);
    /**
     * Update current editor view when value is changed
     */
    useEffect(() => {
        if (!containerRef.current)
            return;
        if (!editorRef.current)
            return;
        const { state } = editorRef.current;
        if (value !== state.doc.toString()) {
            editorRef.current.dispatch({
                changes: {
                    from: 0,
                    to: state.doc.length,
                    insert: value,
                },
            });
        }
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        .cm-editor { 
          height: 100%;
          width: 100%;
        }
      ` }), _jsx(Box, { w: "100%", h: "100%", ref: containerRef })] }));
};
